import { makeAutoObservable, action, toJS, runInAction } from "mobx";
import { Message } from "@arco-design/web-react";
import { setTokenToLocalStorage } from "@/utils/token";
import { makePersistable } from "mobx-persist-store";
import {
  getSyntheticSubInfo,
  getSyntheticVideoList,
  getalbumSubTask,
} from "@/services/taskCenter/taskList";
import _ from "lodash";
const groupByTask = (data, type) => {
  const grouped = data.reduce((acc, item) => {
    const key = item[type];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {});

  return Object.values(grouped);
};
class VideoResult {
  videoResList = [];
  imageTextList = [];
  videoTimeLine = {
    id: 0,
    medias: [],
    rate: 0,
    time: "00:00",
    timeline: "",
    title: "",
  };
  task_no = [];
  task_id = [];
  videoInfo = {
    aspectRatio: "",
    coverUrl: "",
    duration: 0,
    mediaMarks: [],
    recommend: { bitrate: 0, width: 0, height: 0 },
    timeline: {},
    title: "精剪-3",
  };
  videoVisible = false;
  videoResultInfo = [];
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "VideoResult",
      properties: [
        "videoResList",
        "videoTimeLine",
        "task_no",
        "task_id",
        "imageTextList",
      ],
      storage: window.localStorage,
    });
  }
  setTask_no = action(async (val) => {
    const nArr = [...this.task_no];
    nArr.push(val);
    this.task_no = nArr;
    await this.getVideoResList(nArr);
  });
  setTask_nos = action(async (val) => {
    runInAction(() => {
      // 在 runInAction 内部做状态更新
      let nArr = [...this.task_no];
      nArr = nArr.concat(val);
      this.task_no = nArr;
    });
    await this.getVideoResList(this.task_no);
  });
  setTask_id = async (val) => {
    runInAction(() => {
      // 在 runInAction 内部做状态更新
      let nArr = [...this.task_id];
      nArr = nArr.concat(val);
      this.task_id = nArr;
    });
    // 获取并处理任务信息，保证异步更新状态后再处理数据
    await this.getImageTextList(this.task_id);
  };
  filterTask_no = action((id) => {
    runInAction(() => {
      const nArr = this.task_no.filter((v) => v !== id);
      this.task_no = nArr;
      this.videoResList = this.videoResList.filter((v) => v.id !== id);
    });
  });

  filterTask_id = action((id) => {
    runInAction(() => {
      const nArr = this.task_id.filter((v) => v !== id);
      this.task_id = nArr;
      this.imageTextList = this.imageTextList.filter((v) => v.id !== id);
    });
  });

  getVideoResList = action(async (task_no) => {
    if (!task_no || !task_no.length) {
      this.videoResList = [];
      return;
    }
    setTimeout(async () => {
      const res = await getSyntheticSubInfo(JSON.stringify(task_no));
      if (res?.items) {
        const info = res.items.map((v) => ({
          ...v,
          name: v.title,
          id: v.timeline_id,
        }));

        let nArr = [...this.videoResList];
        const getVideoList = groupByTask(info, "task_no").map((v: any, i) => ({
          id: task_no[i],
          update_at: v[0].created_at * 1000,
          taskList: v.map((item) => ({
            ...item,
            progress: Math.floor(
              (v.filter((k) => k.status === 1).length / v.length) * 100,
            ),
          })),
          type: "compound",
        }));

        runInAction(() => {
          if (nArr.length) {
            getVideoList.forEach((item, i) => {
              if (item.id == nArr[i]?.id) {
                nArr[i] = {
                  ...item,
                  taskList: item.taskList.map((v, k) => ({
                    ...v,
                    isExamine: nArr[i].taskList[k]?.isExamine || false,
                  })),
                };
              } else {
                nArr.push(item);
              }
            });
          } else {
            nArr = getVideoList;
          }
          this.videoResList = nArr;
        });
      }
    }, 800);
  });

  getImageTextList = action(async (task_id) => {
    if (!task_id || !task_id.length) {
      this.imageTextList = [];
      return;
    }
    setTimeout(async () => {
      const res = await getalbumSubTask(`[${task_id}]`);
      if (res?.items) {
        const info = res.items.map((v) => ({
          ...v,
          name: v.title,
          task_type: "imageText",
        }));

        let nArr = [...this.imageTextList];
        const getImageTextList = groupByTask(info, "task_id").map(
          (v: any, i) => ({
            id: task_id[i],
            update_at: v[0].created_at * 1000,
            taskList: v.map((item) => ({
              ...item,
              progress: Math.floor(
                (v.filter((k) => k.status === 2).length / v.length) * 100,
              ),
              task_type: "imageText",
            })),
            type: "imageText",
          }),
        );

        runInAction(() => {
          if (nArr.length) {
            getImageTextList.forEach((item, i) => {
              if (item.id == nArr[i]?.id) {
                nArr[i] = {
                  ...item,
                  taskList: item.taskList.map((v, k) => ({
                    ...v,
                    isExamine: nArr[i].taskList[k]?.isExamine || false,
                    task_type: "imageText",
                  })),
                };
              } else {
                nArr.push(item);
              }
            });
          } else {
            nArr = getImageTextList;
          }
          this.imageTextList = nArr;
        });
      }
    }, 800);
  });

  clearExamine = action(() => {
    const newVideoResList = [...this.videoResList];
    const newImageTextList = [...this.imageTextList];
    runInAction(() => {
      this.videoResList = newVideoResList.map((item) => ({
        ...item,
        taskList: item.taskList.map((v) => ({ ...v, isExamine: true })),
      }));
      this.imageTextList = newImageTextList.map((item) => ({
        ...item,
        taskList: item.taskList.map((v) => ({ ...v, isExamine: true })),
      }));
    });
  });

  setVideoVisible = action(() => {
    this.videoVisible = !this.videoVisible;
  });

  setVideoInfo = action((value) => {
    this.videoInfo = value;
  });

  setVideoResultInfo = action((value) => {
    const nArr = [...this.videoResultInfo];
    const index = nArr.findIndex(
      (item) => item.timeline_id === value.timeline_id,
    );
    runInAction(() => {
      if (index !== -1) {
        nArr[index] = value;
      } else {
        nArr.push(value);
      }
      this.videoResultInfo = nArr;
    });
  });

  setVideoTimeLine = action((value) => {
    this.videoTimeLine = value || {
      id: 0,
      medias: [],
      rate: 0,
      time: "00:00",
      timeline: "",
      title: "",
    };
  });
}

const VideoRes = new VideoResult();
export default VideoRes;
